import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BoundBookEntry } from 'src/app/shared/models/general';
import { SharedService } from 'src/app/shared/services/shared.service';
import {
  concatenateCompanyStreetAddress,
  concatenateCompanyCityStateAddress,
} from 'src/app/shared/functions';
import { ModalID } from 'src/app/shared/models/constants';

@Component({
  selector: 'app-bound-book-print',
  templateUrl: './bound-book-print.component.html',
  styleUrls: ['./bound-book-print.component.scss'],
  standalone: true,
  imports: [DatePipe, TitleCasePipe],
})
export class BoundBookPrintComponent implements OnInit {
  bound_book_entries: BoundBookEntry[] = [];
  company_street_address = concatenateCompanyStreetAddress(
    this.sharedService.company_info,
  );
  company_city_state_zip = concatenateCompanyCityStateAddress(
    this.sharedService.company_info,
  );
  currentDate = new Date();

  constructor(
    public sharedService: SharedService,
    private modalService: BsModalService,
  ) {}

  ngOnInit(): void {
    if (this.bound_book_entries) {
      this.bound_book_entries.sort((a, b) => a.firearm_id - b.firearm_id);
    }
  }

  closeModalClick(): void {
    this.modalService.hide(ModalID.bound_book_print); // Ensure ModalID.bound_book_print is defined or use a generic one if not
  }

  printClick(): void {
    window.print();
  }

  hasModificationEvents(entry: BoundBookEntry): boolean {
    return (
      entry.event_log?.some((event) => event.event?.includes('Modify')) || false
    );
  }

  getModificationEvents(entry: BoundBookEntry) {
    return (
      entry.event_log?.filter((event) => event.event?.includes('Modify')) || []
    );
  }

  getFormattedChanges(
    valueFrom: any,
    valueTo: any,
  ): Array<{ key: string; from: any; to: any }> {
    const changes: Array<{ key: string; from: any; to: any }> = [];

    if (!valueFrom || !valueTo) {
      return changes;
    }

    // Handle case where valueFrom and valueTo are objects with multiple properties
    if (typeof valueFrom === 'object' && typeof valueTo === 'object') {
      const keys = Object.keys(valueFrom);
      keys.forEach((key) => {
        changes.push({
          key: key,
          from: valueFrom[key],
          to: valueTo[key],
        });
      });
    }

    return changes;
  }
}
